export enum BiddingTabs {
    bidding = 'bidding',
    participants = 'dealers'
}
